module.exports = __webpack_public_path__ + "static/media/38-iveco-mercedes.e3df8201.jpg";